import React from "react";
import { Link } from "react-router-dom";
import TrustLayout, { H2 } from "./TrustLayout";

export default function About() {
  return (
    <TrustLayout
      meta={{
        path: "/about",
        kicker: "Who is behind this",
        title: "About My Centennial Plan & Founder Hank Beach | Centennial",
        description:
          "My Centennial Plan is a free retirement-readiness platform founded by Hank Beach — 44+ years of operations and business-systems experience turned into practical planning tools families can actually use.",
        h1: "About My Centennial Plan",
        reviewed: "June 2026",
      }}
    >
      <p>
        My Centennial Plan exists for one reason: retirement planning should not require a
        paywall, a signup form, or a sales pitch. Every tool on this site — the 100-year Monte
        Carlo calculator, the readiness checklist and workbook, the medication safety organizer,
        and the education library — is free to use, with nothing stored on our servers.
      </p>

      <H2>The founder</H2>
      <p>
        <strong>Hank Beach</strong> is an entrepreneur, operations leader, and business-systems
        developer with more than 44 years of experience across the automotive, collision repair,
        dealership, service, and franchise industries — including leadership and operational work
        connected with respected organizations such as Lithia, Caliber Collision, CARSTAR,
        Fletcher Jones, and the Assured Performance Network.
      </p>
      <p>
        As the founder of Centennial Planning Group and Centennial Business Systems, Hank turns
        decades of hands-on experience into practical, repeatable tools — not theory. My
        Centennial Plan applies that same philosophy to retirement: make complicated subjects
        easier for individuals and families to understand, prepare for the future, and pass
        useful knowledge forward to the next generation.
      </p>
      <p>
        His guiding belief is simple: success is not measured only by what one person builds — it
        is measured by what that person teaches, what others can carry forward, and how many
        people are better equipped because the knowledge was passed on.
      </p>

      <H2>Editorial standards</H2>
      <p>
        Every educational page on this site follows the same rules: plain English over jargon,
        primary sources over hearsay, and honest uncertainty over false precision. Calculations
        are explained openly on our <Link className="text-[#2B5339] underline" to="/methodology">Methodology page</Link>.
        Educational content carries a visible "last reviewed" date. We cite primary sources —
        IRS, Social Security Administration, Medicare, and published academic research — wherever
        a factual claim depends on them.
      </p>

      <H2>Corrections policy</H2>
      <p>
        If we get something wrong, we fix it and update the page's review date. Found an error?
        Tell us via the <Link className="text-[#2B5339] underline" to="/contact">contact page</Link> — corrections
        are reviewed by a human and typically addressed within a week.
      </p>

      <H2>How the site is funded</H2>
      <p>
        The calculator and guides are free for individuals, forever. The site is funded by
        optional professional tools: advisor white-label embeds, featured advisor listings,
        homepage sponsorships, a $3 AI-critique unlock, and affiliate book links (always
        disclosed). No tool ever requires payment to get your full results.
      </p>
    </TrustLayout>
  );
}
